/**
 * @module Widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';

// Constant
import { TOOLTIP_CONSTANTS } from '@support/shared/widgets/constants/widgets.constants';

export interface IElem {
  tagName: string;
}
@Component({
  selector: 'tmo-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['../../../../../../style-sheets/components/tooltip.component.scss'],
})
export class TooltipComponent implements OnInit, OnDestroy {
  /**
   * Target element to attach the overlay, valid values are "body", "target" or a local
   * ng-template variable of another element.
   */
  @Input() public appendTo?: string;
  /**
   * Text of the tooltip.
   */
  @Input() public text?: string;
  /**
   * Event to show the tooltip, valid values are hover and focus.
   */
  @Input() public event?: string;
  /**
   * Tab index for tooltip
   */
  @Input() public tabIndex?: number;
  /**
   * Position of the tooltip, valid values are right, left, top and bottom.
   */
  @Input() public position?: string;
  /**
   * Attached to the aria-label attribute of the host element. In most cases, arial-labelledby will
   * take precedence so this may be omitted.
   */
  /* tslint:disable:no-input-rename */
  @Input('aria-label') public ariaLabel?: string;
  /**
   * Reference element to get the tooltip
   */
  @ViewChild('toolTip', { static: true }) public toolTip: ElementRef;

  /**
   * Trigger the tooltip to blur when pressed escape key
   */
  @HostListener('document:keydown.escape', ['$event'])
  public onKeydownHandler(event: KeyboardEvent): void {
    if (this.toolTip && event.key == 'Escape') {
      this.toolTip.nativeElement.blur();
    }
  }
  /**
   * Trigger the calclulations of the offset position
   */
  @HostListener('click', ['$event'])
  public onClick(): void {
    this.offsetCalculation();
  }

  constructor(public elem: ElementRef) {}

  public ngOnInit(): void {
    this.setDefaultData();
  }
  /**
   * Calclulate the offset position
   */
  public offsetCalculation(): void {
    const doc = document;
    const win = window;
    const style = TOOLTIP_CONSTANTS.STYLE;
    const arrowHeight = 16;
    const arrowWidth = 30;
    const half = 2;
    const tooltipWidth = 250;
    const tooltip = doc.getElementsByClassName('p-tooltip')[0];
    const tooltipArrow = doc.getElementsByClassName('p-tooltip-arrow')[0];
    const tooltipLeftPosition = this.elem.nativeElement.getBoundingClientRect().left;
    const tooltipRightPosition = this.elem.nativeElement.getBoundingClientRect().right;
    // if (SETTINGS.CHANNEL.toLowerCase() !== CHANNEL_CONST.web && SETTINGS.CHANNEL.toLowerCase() !== CHANNEL_CONST.nrd) {
    //   tooltip[style].top = (Number(this.elem.nativeElement.getBoundingClientRect().top)
    //   + arrowHeight).toString().concat('px');
    // }
    if (this.elem.nativeElement.getBoundingClientRect().left < tooltipWidth / half) {
      tooltip[style].left = (tooltipLeftPosition - half * half).toString().concat('px');
      tooltipArrow[style].left = '0px';
    } else if (win.innerWidth - tooltipRightPosition < tooltipWidth / half) {
      tooltip[style].left = (
        win.innerWidth -
        tooltipWidth -
        (win.innerWidth - tooltipLeftPosition - arrowHeight) +
        half * half
      )
        .toString()
        .concat('px');
      tooltipArrow[style].left = (tooltipWidth + half - arrowWidth).toString().concat('px');
    }
  }

  public ngOnDestroy(): void {}
  /**
   * Initializes default attribute values if nothing is present
   */
  public setDefaultData(): void {
    if (!this.appendTo) {
      this.appendTo = TOOLTIP_CONSTANTS.APPENDTO;
    }
    if (!this.text) {
      this.text = TOOLTIP_CONSTANTS.TEXT;
    }
    if (!this.event) {
      this.event = TOOLTIP_CONSTANTS.EVENT;
    }
    if (!this.tabIndex) {
      this.tabIndex = 0;
    }
    if (!this.position) {
      this.position = TOOLTIP_CONSTANTS.POSITION;
    }
  }
}
